import React from 'react';
import { payFor } from './shopUtils';

const fmtDate = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

// Strip the "Editorial · " / "Abstract · " prefix from a design label.
const designName = (design) => (design && design.label ? design.label.replace(/^[^·]+·\s*/, '') : 'Design');

// StepSummary — order recap, T&Cs, and the pay button (wired to checkout in
// the next phase).
const StepSummary = ({ voucher, amount, design, personalise, currency, canPay, paying, error, onPay, hideButton }) => {
  const pay = payFor(voucher, amount);
  const hasPromo = pay < amount;
  const p = personalise;
  const deliveryLabel = [p.deliverEmail && 'Email', p.deliverPdf && 'PDF'].filter(Boolean).join(' + ') || 'Email';
  const scheduled = p.giftMode === 'gift' && p.deliverWhen === 'scheduled' && p.deliverDate;

  return (
    <section className="gcs-step gcs-summary">
      <div className="gcs-summary-rows">
        <div className="gcs-srow"><span>Gift card</span><strong>{voucher ? voucher.name : 'Gift Card'}</strong></div>
        <div className="gcs-srow"><span>Design</span><strong>{designName(design)}</strong></div>
        <div className="gcs-srow"><span>Value</span><strong>{currency}{amount}</strong></div>
        {hasPromo && (
          <div className="gcs-srow">
            <span>You pay</span>
            <strong>{currency}{pay} <span className="gcs-promo-save">save {currency}{amount - pay}</span></strong>
          </div>
        )}
        {p.giftMode === 'gift' && p.recipientName && (
          <div className="gcs-srow"><span>To</span><strong>{p.recipientName}</strong></div>
        )}
        <div className="gcs-srow">
          <span>Delivery</span>
          <strong>{deliveryLabel}{scheduled ? ` · ${fmtDate(p.deliverDate)}` : ''}</strong>
        </div>
        {voucher && voucher.expiry && (
          <div className="gcs-srow"><span>Expiry</span><strong>{voucher.expiry}</strong></div>
        )}
      </div>

      {voucher && voucher.tc && <p className="gcs-tc">{voucher.tc}</p>}

      {!hideButton && error && <p className="gcs-error">{error}</p>}

      {!hideButton && (
        <button type="button" className="gcs-pay" disabled={!canPay || paying} onClick={onPay}>
          {paying ? 'Redirecting to payment…' : `Pay ${currency}${pay}`}
        </button>
      )}
    </section>
  );
};

export default StepSummary;
